export default __webpack_public_path__ + "static/let-godoy-47299fc47b2bb2b5e6f438d91132a62e.png";